var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54.5,
    height: 51.273,
    viewBox: "0 0 54.5 51.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1041",
    "data-name": "Group 1041",
    transform: "translate(-454.5 -291.364)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1040",
    "data-name": "Group 1040"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1039",
    "data-name": "Group 1039",
    transform: "translate(441.5 277.364)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1196",
    "data-name": "Path 1196",
    d: "M30.818,39.636A12.818,12.818,0,1,1,43.636,26.818,12.831,12.831,0,0,1,30.818,39.636Zm0-21.364a8.545,8.545,0,1,0,8.545,8.545A8.554,8.554,0,0,0,30.818,18.273Z",
    transform: "translate(5.682)",
    fill: "#262a68"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1197",
    "data-name": "Path 1197",
    d: "M60,50.5H55.727a19.227,19.227,0,1,0-38.455,0H13a23.5,23.5,0,0,1,47,0Z",
    transform: "translate(0 14.773)",
    fill: "#262a68"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_321",
    "data-name": "Ellipse 321",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(485 313)",
    fill: "#edf6fd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1198",
    "data-name": "Path 1198",
    d: "M-3169.1-5015.709h14",
    transform: "translate(3659.589 5340.708)",
    fill: "none",
    stroke: "#262a68",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1199",
    "data-name": "Path 1199",
    d: "M0,0H14",
    transform: "translate(497.494 332) rotate(-90)",
    fill: "none",
    stroke: "#262a68",
    strokeWidth: 4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/userAdd.b75fa2e98827803568f43462b49898a5.svg";
export { ForwardRef as ReactComponent };